import React from 'react';
import { Component } from 'react';
import tick from '../../assets/images/newui/sellersignup/tick.svg'
import './FeatureListItem.less'

class FeatureListItem extends Component {
    render() {
        return <div className='feature-list-item'>
            <img src={tick}></img>
            <div className={`feature-list-item-content${this.props.isHighlighted ? ' highlighted' : ''}`}>{this.props.content}</div>
        </div>
    }
}

export default FeatureListItem;